package io.horion.cv.models

data class KanbanCard(
    val id: String,
    val jobTitle: String,
    val company: String = "",
    val date: String = "",
    val isEditing: Boolean = false
)

data class KanbanColumn(
    val label: String,
    val cards: List<KanbanCard> = emptyList()
)

